import { render, staticRenderFns } from "./getBannerView.vue?vue&type=template&id=fc3b5040&scoped=true&"
import script from "./getBannerView.vue?vue&type=script&lang=js&"
export * from "./getBannerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3b5040",
  null
  
)

export default component.exports